import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
    initial: {
        store_logo: "",
        primary_color: "#9E2064",
        title_text_color: "#1f1f1f",
        body_text_color: "#666666",
        background_color: "#FFFFFF",
        title_font_family: "",
        body_font_family: ""
    },
    custom: {
        store_logo: "",
        primary_color: "#9E2064",
        title_text_color: "#1f1f1f",
        body_text_color: "#666666",
        background_color: "#FFFFFF",
        title_font_family: "",
        body_font_family: ""
    },
    past: [],
    future: []
};

// Create the slice
const customizeSlice = createSlice({
    name: 'customize',
    initialState,
    reducers: {
        updateState: (state, action) => {
            // Push the current state to the past stack
            state.past.push(state.custom);

            // Clear the future stack
            state.future = [];

            // Update the present state with the new state
            state.custom = { ...state.custom, ...action.payload };
        },
        undo: (state) => {
            if (state.past.length > 0) {
                // Push the current state to the future stack
                state.future.push(state.custom);

                // Pop the last state from the past stack and set it as the present state
                state.custom = state.past.pop();
            }
        },
        redo: (state) => {
            if (state.future.length > 0) {
                // Push the current state to the past stack
                state.past.push(state.custom);

                // Pop the last state from the future stack and set it as the present state
                state.custom = state.future.pop();
            }
        },
        setInitial: (state) => {
            state.custom = initialState.initial;
            state.past = [];
            state.future = [];
        }
    }
});

// Export actions and reducer
export const { updateState, undo, redo ,setInitial} = customizeSlice.actions;
export default customizeSlice.reducer;
